import {
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
} from "../../../ui/dropdown-menu";
import { RadioGroupType, RadioItemType } from "../types";

export const RadioItem = ({ radioItem }: { radioItem: RadioItemType }) => {
  return (
    <DropdownMenuRadioItem
      className="m-0 rounded-none gap-2 pl-3 pr-9 py-1.5"
      value={radioItem.value}
      disabled={radioItem.disabled}
      onSelect={event => event.preventDefault()}
    >
      {radioItem.icon}
      {radioItem.label}
    </DropdownMenuRadioItem>
  );
};
export const RadioGroup = ({
  radioGroupItem,
}: {
  radioGroupItem: RadioGroupType;
}) => {
  return (
    <>
      <DropdownMenuRadioGroup
        value={radioGroupItem.value}
        onValueChange={radioGroupItem.onValueChange}
      >
        {radioGroupItem.radioItems.map((radioItem, index) => (
          <RadioItem key={`item-${index}`} radioItem={radioItem} />
        ))}
      </DropdownMenuRadioGroup>
      {radioGroupItem.separator && <DropdownMenuSeparator />}
    </>
  );
};
